import React from 'react';

const FlexCol = ({ children, className = '', ...attrs }) => {
  let classes = 'flex-col';

  if ( className ) {
    classes += ` ${className}`;
  }

  return (
    <div className={classes} {...attrs}>
      {children}
    </div>
  );
};

export default FlexCol;
